"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRepo = void 0;
const FirebaseRepo_1 = require("../../core/infra/FirebaseRepo");
const Res_1 = require("../../core/logic/Res");
const UserOrgMapMap_1 = require("../mappers/UserOrgMapMap");
const UnitMap_1 = require("../mappers/UnitMap");
const UserMap_1 = require("../mappers/UserMap");
const SetupsMap_1 = require("../mappers/SetupsMap");
const AccountMap_1 = require("../mappers/AccountMap");
const TrackerMap_1 = require("../../core/mappers/TrackerMap");
const ResourceMap_1 = require("../mappers/ResourceMap");
const OrganizationMap_1 = require("../mappers/OrganizationMap");
const ResourceEventMap_1 = require("../mappers/ResourceEventMap");
const InstalmentTemplateMap_1 = require("../mappers/InstalmentTemplateMap");
const GenericMap_1 = require("../mappers/GenericMap");
const Role_1 = require("../../core/domain/Role");
const utils_1 = require("../../core/infra/utils");
const FbUserRecordMap_1 = require("../mappers/FbUserRecordMap");
const genericRoleDefs_1 = require("../domain/definitions/genericRoleDefs");
class UserRepo extends FirebaseRepo_1.FirebaseRepo {
    constructor(app, ctx) {
        super(app, ctx);
    }
    //TODO - replace any with unknown
    //TODO test
    async fetchStPermissions(options) {
        return this.fetchOne(this.ouRefs.rootStoragePermissions, "", GenericMap_1.toDomainRaw, options);
    }
    //----------//TODO test
    async fetchDbPermissions(options) {
        return this.fetchOne(this.ouRefs.rootDbPermissions, "", GenericMap_1.toDomainRaw, options);
    }
    //----------//TODO test
    async fetchPortalUiPermissions(options) {
        return this.fetchOne(this.ouRefs.portalUiPermissions, "", GenericMap_1.toDomainRaw, options);
    }
    //TODO test
    async fetchAppUiPermissions(options) {
        return this.fetchOne(this.ouRefs.appUiPermissions, "", GenericMap_1.toDomainRaw, options);
    }
    //----------
    async fetchInstalmentTemplate(key, options) {
        return this.fetchOne(this.rootRefs.instalmentTemplates, key, InstalmentTemplateMap_1.InstalmentTemplateMap.toDomain, options);
    }
    async fetchInstalmentTemplates(options) {
        return this.fetch(this.rootRefs.instalmentTemplates, InstalmentTemplateMap_1.InstalmentTemplateMap.toDomain, options);
    }
    async updateInstalmentTemplate(obj, cb) {
        return super.updateItem(this.rootRefs.instalmentTemplates, obj.id.toString(), obj, cb);
    }
    //----------
    async fetchResourceEvent(type, key, options) {
        return this.fetchOne(`${this.ouRefs.resourceEvents}/${type}`, key, ResourceEventMap_1.ResourceEventMap.toDomain, options);
    }
    async fetchResourceEvents(type, options) {
        return this.fetch(`${this.ouRefs.resourceEvents}/${type}`, ResourceEventMap_1.ResourceEventMap.toDomain, options);
    }
    async updateResourceEvent(type, obj, cb) {
        return super.updateItem(`${this.ouRefs.resourceEvents}/${type}`, obj.id.toString(), obj, cb);
    }
    //--------------
    async fetchActiveInstalment(type, key, options) {
        return this.fetchOne(`${this.ouRefs.activeInstalments}/${type}`, key, ResourceEventMap_1.ResourceEventMap.toDomain, options);
    }
    async fetchActiveInstalments(type, options) {
        return this.fetch(`${this.ouRefs.activeInstalments}/${type}`, ResourceEventMap_1.ResourceEventMap.toDomain, options);
    }
    async updateActiveInstalment(t, obj, cb) {
        return super.updateItem(`${this.ouRefs.activeInstalments}/${t}`, obj.id.toString(), obj, cb);
    }
    //--------------
    async fetchResource(type, key, options) {
        return this.fetchOne(`${this.ouRefs.resources}/${type}`, key, ResourceMap_1.ResourceMap.toDomain, options);
    }
    async fetchResources(type, options) {
        return this.fetch(`${this.ouRefs.resources}/${type}`, ResourceMap_1.ResourceMap.toDomain, options);
    }
    async updateResource(type, obj, cb) {
        return super.updateItem(`${this.ouRefs.resources}/${type}`, obj.id.toString(), obj, cb);
    }
    //--------------
    async fetchUserOrgMap() {
        return super.fetchItem({
            toDomain: UserOrgMapMap_1.UserOrgMapMap.toDomain,
            ref: this.rootRefs.userOrgMap,
            key: "",
        }); // TODO REF fix key
    }
    //TODO - replace any with unknown
    async fetchOrg(key, options) {
        return this.fetchOne(this.rootRefs.organizations, key, OrganizationMap_1.OrganizationMap.toDomain, options);
    }
    async fetchOrgs(options) {
        return this.fetch(this.rootRefs.organizations, OrganizationMap_1.OrganizationMap.toDomain, options);
    }
    async updateOrg(org, cb) {
        return super.updateEntity(org, cb);
    }
    //---------------------
    async fetchFcmTokensUser(options) {
        return this.fetch(this.ouRefs.fcmTokens, TrackerMap_1.TrackerMap.toDomain, options);
    }
    async fetchFcmTokensAll() {
        return utils_1.rslv((async function (repo) {
            const res = [];
            const tSnap = await repo.db.ref(repo.rootRefs.fcmTokens).once("value");
            const snapEmail = await repo.db.ref(repo.rootRefs.userEmailMap).once("value");
            tSnap.forEach((userSnap) => {
                userSnap.forEach((tokenSnap) => {
                    if (tokenSnap.hasChildren()) {
                        res.push({
                            tracker: TrackerMap_1.TrackerMap.toDomain(tokenSnap.val(), tokenSnap.ref.toString(), false),
                            userId: userSnap.key,
                            email: snapEmail.child(userSnap.key).val(),
                        });
                    }
                });
            });
            return res;
        })(this));
    }
    async updateFcmToken(token, cb) {
        return super.updateItem(this.ouRefs.fcmTokens, token.key, token, cb);
    }
    async fetchUnitsCnt() {
        const snap = await this.db.ref(this.ouRefs.units).once("value");
        return snap.numChildren() || 0;
    }
    async fetchUnitsIds() {
        return utils_1.rslv((async function (repo) {
            const snap = await repo.db.ref(repo.ouRefs.units).once("value");
            const res = [];
            snap.forEach((child) => {
                res.push(child.key);
            });
            return res;
        })(this));
    }
    async fetchActiveUsersEmails() {
        return utils_1.rslv((async function (repo) {
            const snapPresence = await repo.db.ref(repo.rootRefs.webPresence).once("value");
            const snapEmail = await repo.db.ref(repo.rootRefs.userEmailMap).once("value");
            const res = [];
            snapPresence.forEach((child) => {
                res.push({ userId: child.key, email: snapEmail.child(child.key).val() });
            });
            return res;
        })(this));
    }
    async fetchUnits(options) {
        return this.fetch(this.ouRefs.units, UnitMap_1.UnitMap.toDomain, options);
    }
    async fetchUnit(key, options) {
        return this.fetchOne(this.ouRefs.units, key, UnitMap_1.UnitMap.toDomain, options);
    }
    async updateUnit(org, cb) {
        return super.updateEntity(org, cb);
    }
    async updateUnitBatch(units, cb) {
        const keyValueObjects = units.map((u) => ({ key: u.id.toValue(), value: u }));
        return super.updateBatch(this.ouRefs.units, keyValueObjects, cb);
    }
    async fetchUsers(options) {
        return this.fetch(this.ouRefs.users, UserMap_1.UserMap.toDomain, options);
    }
    async fetchRolesAllUsers() {
        const rolesCodesRes = await utils_1.rslv(this.db.ref(this.ouRefs.rolesAllUsers).once("value"));
        if (rolesCodesRes.isFail)
            return Res_1.Res.fail(`Failed to fetch role codes: ${rolesCodesRes.errMsg()}`);
        const roleCodesSnap = rolesCodesRes.getValue();
        const cusRes = await utils_1.rslv(this.db.ref(this.ouRefs.customRoleDefs).once("value"));
        if (cusRes.isFail)
            return Res_1.Res.fail(`Failed to fetch customRoleDefs: ${rolesCodesRes.errMsg()}`);
        const customRolesDefsByCode = cusRes.val() || {};
        const rolesByUsers = {};
        if (roleCodesSnap.hasChildren())
            roleCodesSnap.forEach((byUser) => {
                rolesByUsers[byUser.key] = {};
                byUser.forEach((roleCodeSnap) => {
                    const roleCode = roleCodeSnap.key;
                    Role_1.Role.addRoleDTOByCode(rolesByUsers[byUser.key], roleCode, customRolesDefsByCode);
                });
            });
        return Res_1.Res.ok(rolesByUsers);
    }
    async fetchOrgOwner() {
        const fetchRolesRes = await this.fetchRolesAllUsers();
        if (fetchRolesRes.isFail || !Object.keys(fetchRolesRes.getValue() || {}).length)
            return Res_1.Res.fail(`Failed to fetch user roles: ${fetchRolesRes.errMsg()}`);
        const [userId] = Object.entries(fetchRolesRes.getValue() || {}).find(([, userRoles]) => {
            return Object.keys(userRoles || {}).find((key) => key === genericRoleDefs_1.genericOrgOwnerRoleDef.key);
        });
        return this.fetchOne(this.ouRefs.users, userId, UserMap_1.UserMap.toDomain);
    }
    async fetchGraphics() {
        const gStateRes = await utils_1.rslv(this.db.ref(this.rootRefs.globalState).once("value"));
        if (gStateRes.isFail || !gStateRes.getValue().exists())
            return Res_1.Res.fail(`Failed to fetch globalState: ${gStateRes.errMsg()}`);
        const { graphicsOrgId, graphicsUnitId } = gStateRes.val();
        if (!graphicsOrgId || !graphicsUnitId)
            return Res_1.Res.fail("Failed to read globalState");
        const grUnitRes = await utils_1.rslv(this.db.ref(`orgData/${graphicsOrgId}/units/${graphicsUnitId}/users`).once("value"));
        if (grUnitRes.isFail || !grUnitRes.getValue().exists())
            return Res_1.Res.fail(`Failed to fetch graphics unit users: ${grUnitRes.errMsg()}`);
        const grUnitUsers = grUnitRes.val();
        const grUsersRes = await this.fetch(`orgData/${graphicsOrgId}/users`, UserMap_1.UserMap.toDomain);
        if (grUsersRes.isFail)
            return Res_1.Res.fail(`Failed to fetch graphics organization users: ${grUsersRes.errMsg()}`);
        const graphics = [];
        grUsersRes.getValue().ok.forEach((grUser) => {
            if (grUnitUsers[grUser.idStr] === true)
                graphics.push(grUser);
        });
        return Res_1.Res.ok(graphics);
    }
    async listUsersFromAuth(limit, nextPageToken) {
        const authUsersRes = await utils_1.rslv(this.app.cf.onCallActionApi({ action: "LIST_USERS", limit, nextPageToken }));
        if (authUsersRes.isFail)
            return Res_1.Res.fail(`Failed to list users from auth: ${authUsersRes.errMsg()}`);
        const { data: { users: resUsers, pageToken }, } = authUsersRes.getValue();
        const users = resUsers.map((user) => FbUserRecordMap_1.FbUserRecordMap.toDomain(user, null, null, false));
        return Res_1.Res.ok({ users, pageToken });
    }
    async fetchUser(key, options) {
        return this.fetchOne(this.ouRefs.users, key, UserMap_1.UserMap.toDomain, options);
    }
    async removeUser(key, cb) {
        return super.removeItem(this.ouRefs.users, key, cb);
    }
    async updateUser(user, cb) {
        return super.updateEntity(user, cb);
    }
    async updateUserBatch(users, cb) {
        const keyValueObjects = users.map((u) => ({ key: u.id.toValue(), value: u }));
        return super.updateBatch(this.ouRefs.users, keyValueObjects, cb);
    }
    async fetchOrgSetting(options) {
        return this.fetchOne(this.ouRefs.orgSetting, "data", SetupsMap_1.SetupsMap.toDomain, options);
    }
    async removeOrgSetting(cb) {
        return super.removeItem(this.ouRefs.orgSetting, "data", cb);
    }
    async updateOrgSetting(orgSetting, cb) {
        return super.updateItem(this.ouRefs.orgSetting, "data", orgSetting, cb);
    }
    async fetchUnitsConfig(key, options) {
        return this.fetchOne(this.ouRefs.unitsConfigs, key, SetupsMap_1.SetupsMap.toDomain, options);
    }
    async fetchAccounts(options) {
        return this.fetch(this.rootRefs.accounts, AccountMap_1.AccountMap.toDomain, options);
    }
    async fetchAccount(key, options) {
        return this.fetchOne(this.rootRefs.accounts, key, AccountMap_1.AccountMap.toDomain, options);
    }
    async removeAccount(key, cb) {
        return super.removeItem(this.rootRefs.accounts, key, cb);
    }
    async updateAccount(account, cb) {
        return super.updateEntity(account, cb);
    }
    async updateAccountBatch(accounts, cb) {
        const keyValueObjects = accounts.map((a) => ({ key: a.id.toValue(), value: a }));
        return super.updateBatch(this.rootRefs.accounts, keyValueObjects, cb);
    }
    async fetch(ref, toDomain, options) {
        return super.fetchArray({ ref, toDomain, ...options }); //TODO test if options are empty
    }
    async fetchOne(ref, key, toDomain, options) {
        return super.fetchItem({ ref, toDomain, key, ...options }); //TODO test if options are empty
    }
}
exports.UserRepo = UserRepo;
//# sourceMappingURL=UserRepo.js.map